import React from 'react';
import * as ReactDom from 'react-dom';
import { ThemeProvider, createTheme, theme } from '@piiqtechnologies/ui-components';
import { InfoHotspot } from './InfoHotspot.js';
import { SceneHotspot } from './SceneHotspot.js';
import HotspotEditView from './HotspotEditView.js';

const createHotspot = (hotspotDiv, { relatedContext, hotspot, sceneId, helpers, brandingColor, infospot }) => {
    const { isEditing } = relatedContext;
    hotspotDiv.classList.remove("pnlm-sprite");
    hotspotDiv.classList.remove("pnlm-hotspot");
    hotspotDiv.classList.remove("pnlm-scene");
    hotspotDiv.classList.remove("pnlm-pointer");
    ReactDom.render(React.createElement(ThemeProvider, { theme: createTheme(Object.assign(Object.assign({}, theme), { palette: Object.assign(Object.assign({}, theme.palette), { secondary: Object.assign(Object.assign({}, theme.palette.secondary), { main: brandingColor || theme.palette.secondary.main }) }) })) }, (!isEditing &&
        ((infospot && (React.createElement(InfoHotspot, Object.assign({ relatedContext: relatedContext, sceneId: sceneId, helpers: helpers }, hotspot)))) || (React.createElement(SceneHotspot, Object.assign({ relatedContext: relatedContext, sceneId: sceneId, helpers: helpers }, hotspot))))) || (React.createElement(HotspotEditView, { relatedContext: relatedContext, sceneId: sceneId, helpers: helpers, infospot: infospot, hotspot: hotspot }))), hotspotDiv);
};

export { createHotspot };
